import React from 'react';
import Icon from '../common/icons/Icon';

export default ({ activeClass }) => {
  return (
    <div className="admin-paper__list--wrapper">
      <div className="golf-schools__attendee-list">
        <div className="admin-paper__header">
          <h3>
            List of Attendees ({activeClass.users.length}/{activeClass.limit})
          </h3>
        </div>
        <ul className="admin-paper__list">
          {activeClass.users && activeClass.users.length ? (
            activeClass.users.map((user, index) => (
              <li key={user.id}>
                <div className="admin-paper__list__title">
                  <Icon icon="Person" />
                  <div className="title">{user.name}</div>
                  <div className="subtitle">{user.email}</div>
                  <div className="days">{user._pivot_message}</div>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no users enrolled in this class</div>
          )}
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/golf-schools/ClassUserList.js